import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IInteractiveDocumentService = ( createDecorator('IInteractiveDocumentService'));
export { IInteractiveDocumentService };
